<template>
  <el-table-column
    prop="storage_user.last_name"
    sortable="custom"
    label="Raktár vezető"
    show-overflow-tooltip
    min-width="140"
  >
    <template slot-scope="scope">
      <div
        v-if="scope.row.storage_user"
        style="display: inline-block;"
      >
        {{ scope.row.storage_user.last_name }} {{ scope.row.storage_user.first_name }}
      </div>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'storage_user.last_name',
  };
</script>
